'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./FileTypeThumb.scss');

var FileTypeThumb = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FileTypeThumb, _Component);

  function FileTypeThumb() {
    (0, _classCallCheck3.default)(this, FileTypeThumb);
    return (0, _possibleConstructorReturn3.default)(this, (FileTypeThumb.__proto__ || (0, _getPrototypeOf2.default)(FileTypeThumb)).apply(this, arguments));
  }

  (0, _createClass3.default)(FileTypeThumb, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(styles.fileTypeThumb, className) },
        _react2.default.createElement('div', { className: styles.corner }),
        _react2.default.createElement('div', { className: styles.top }),
        _react2.default.createElement('div', { className: styles.bottom }),
        _react2.default.createElement(
          'div',
          { className: styles.fileType },
          children
        )
      );
    }
  }]);
  return FileTypeThumb;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
}, _temp);
exports.default = FileTypeThumb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FileTypeThumb/FileTypeThumb.js
// module id = 1992
// module chunks = 1